import { Container } from "@/components/Container"
import { RainForm } from "@/components/verification/RainForm"
import { RainSteps } from "@/components/verification/RainSteps"
import { ClientType, RainCorporateFormProvider, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import clsx from "clsx"
import { memo } from "react"
import { FormattedMessage } from "react-intl"
import { NavLink, Route, Switch, useLocation, useParams, useRouteMatch } from "react-router-dom"

const Link = ({ path, title, isMobile }: { title: string; path: string; isMobile?: boolean }) => (
  <NavLink
    to={path}
    activeClassName="btn-blue active !text-[#78ff73]"
    className={clsx("btn-reset btn-sq btn-trpr input-brdr no-decorate md:w-auto text-center", { "w-[50%]": !isMobile })}
  >
    <FormattedMessage id={title} />
  </NavLink>
)
const VerificationsPageComponent = () => {
  const { client_type, card_active, iban_active } = useStoreClient(selectUser)
  const isCorporateAccount = client_type === ClientType.Coroporate
  const path = useRouteMatch().path
  const pathname = useLocation().pathname
  const { type } = useParams<{ type?: string }>()
  return (
    <Container maxW={980}>
      <div className="div-h1 text-center">
        <FormattedMessage id="account_verification" />
      </div>
      <div className="additional-links d-flex justify-content-center my-4">
        <NavLink to={`${path.replace(/:.*\??/, type ?? "")}`} exact className="additional-links__link">
          <h3 className="h4 additional-links__link-title">
            <FormattedMessage id="pa_147" />
          </h3>
        </NavLink>
        <NavLink to={`${path.replace(/:.*\??/, type ?? "")}/form`} className="additional-links__link">
          <h3 className="h4 additional-links__link-title">
            <FormattedMessage id="pa_148" />
          </h3>
        </NavLink>
      </div>
      <RainCorporateFormProvider>
        <Switch>
          <Route path={`${path}`} exact component={RainSteps} />
          <Route path={`${path}/form`} component={RainForm} />
        </Switch>
      </RainCorporateFormProvider>
    </Container>
  )
}

export const CompanyVerifications = memo(VerificationsPageComponent)
